import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { AdminApi } from "../../api/AdminApi";

import {
    Box,
    Grid,
    Container,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Paper,
    Button,
    Backdrop,
    CircularProgress,
    Stack,
} from "@mui/material";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import FormContent from "../../components/dashboardVideo/dashboardVideoFormSchema.jsx";
import { isError, getErrorMsg, validateForm } from "../../helper/FormHelper.jsx";
import { postDataRequest, getDataRequest } from "../../helper/AxiosHelper";
import CommonImagePicker from "../../components/common/CommonImagePicker/CommonImagePicker.jsx";
import CommonOptionSelection from "../../components/common/CommonOptionSelection/CommonOptionSelection.jsx";
import VideoPreview from "../../components/common/VideoPreview/VideoPreview.jsx";

export default function Component() {
    const { dashboardID } = useParams();
    const navigate = useNavigate();
    const formik = useFormik(FormContent.FormikInstance);
    const [currentRecordData, setCurrentRecordData] = useState(null);
    const [isDataPadding, setDataPadding] = useState(true);
    const [thumbnailFile, setThumbnailFile] = useState(null);

    useEffect(() => {
        getDataRequest(`dashboardVideo/show/${dashboardID}`, (isSuccess, data) => {
            if (!isSuccess) {
                console.log("Data not found with id - " + dashboardID);
                setDataPadding(false);
                return;
            }
            const { record } = data;
            const formFieldList = Object.keys(FormContent.FormikInstance.initialValues);
            formFieldList.forEach((field) => {
                formik.setFieldValue(field, record[field] ?? "");
            });
            setCurrentRecordData(record);
            setDataPadding(false);
        });
    }, []);

    const handleUpdate = async () => {
        if (await validateForm(formik)) return;
        const formData = JSON.parse(JSON.stringify(formik.values));

        AdminApi.updateDashboardVideoCallback(
            dashboardID,
            {
                ...formData,
                thumbnail_file: thumbnailFile,
            },
            (isSuccess, data) => {
                if (!isSuccess) {
                    return toast.error("更新失敗");
                }

                toast.success("更新成功");

                let nagivateURL = `/dashboardVideo/update/${dashboardID}`;
                setTimeout(() => navigate(nagivateURL), 1500);

            }
        );
    };

    return (
        <Container maxWidth={"lg"}>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isDataPadding}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <CommonBreadcrumb dbData={currentRecordData} />
            <Box component="form" sx={{ mt: 3 }}>
                <Paper sx={{ px: 3, py: 5 }} elevation={3}>
                    <Grid container rowSpacing={3} columnSpacing={2}>
                        {FormContent.FormControl.map((item, index) => {
                            const gridStyle = "size" in item ? item.size : { xs: 12 };
                            const formControlProps = item.props;

                            if (item.variant === "selector") {
                                return (
                                    <CommonOptionSelection key={`form-section-${index}`} item={item} formik={formik} />
                                );
                            }

                            if (item.variant === "youtube_link") {
                                return (
                                    <Grid item key={`form-section-${index}`} {...gridStyle}>
                                        <Stack spacing={1}>
                                            <TextField
                                                {...formControlProps}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                value={formik.values[formControlProps.id] ?? ""}
                                                error={isError(formik, formControlProps.id)}
                                                helperText={getErrorMsg(formik, formControlProps.id)}
                                                fullWidth
                                            />
                                            <FormHelperText>請輸入 YouTube 連結 或 影片 URL</FormHelperText>
                                            {formik.values[formControlProps.id] && (
                                                <VideoPreview
                                                    url={formik.values[formControlProps.id]}
                                                    title={formControlProps.label}
                                                    showUrl={false}
                                                />
                                            )}
                                        </Stack>
                                    </Grid>
                                );
                            }

                            return (
                                <Grid item key={`form-section-${index}`} {...gridStyle}>
                                    <TextField
                                        {...formControlProps}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        value={formik.values[formControlProps.id] ?? ""}
                                        error={isError(formik, formControlProps.id)}
                                        helperText={getErrorMsg(formik, formControlProps.id)}
                                        fullWidth
                                    />
                                </Grid>
                            );
                        })}

                        <Grid item xs={12}>
                            <CommonImagePicker
                                imageURL={currentRecordData?.thumbnail ?? null}
                                onChange={(file) => setThumbnailFile(file)}
                                onReset={() => setThumbnailFile(null)}
                                uploadCaption="更新 Cover 縮圖"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant="contained" onClick={handleUpdate}>
                                更新
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Container>
    );
}
